<template>
  <div
    v-cloak
    v-if="template && rules"
    class="item-common pt-10 pb-5 px-7 type-etc"
  >
    <div class="header">
      <h1 class="title">{{ $t(template.etcTitle) }}</h1>
      <v-divider></v-divider>
      <p class="desc" v-html="template.guideEtc"></p>
    </div>
    <div class="body">
      <v-form ref="form">
        <v-row>
          <!-- 비상연락처 -->
          <v-col :cols="['A', 'C'].includes(etc) ? 12 : 6">
            <i-text-field
              v-maxlength="'etc_phone_sub'"
              :label="itemLabel('etcPhoneSub')"
              v-model="phoneNumber"
              @blur="formattedPhoneNumber()"
              outlined
              dense
              hide-details="auto"
              :rules="[
                rules.required('etcPhoneSub'),
                rules.maxlength('etcPhoneSub'),
              ]"
              class="rounded-l rounded-r-0"
              :readonly="isReadonly"
            ></i-text-field>
          </v-col>
          <!-- //비상연락처 -->
          <!-- 지원경로 -->
          <v-col cols="6" v-if="!['A', 'C'].includes(etc)">
            <DirectInputSelect
              v-maxlength="'etc_path'"
              :useDirect="itemDirectInput('etcPath')"
              v-model="path"
              :items="itemArray('etcPath')"
              :label="itemLabel('etcPath')"
              @change="save"
              outlined
              dense
              hide-details="auto"
              :rules="[rules.required('etcPath')]"
              class="rounded-l-0 rounded-r"
              :readonly="isReadonly"
            />
          </v-col>
          <!-- //지원경로 -->
        </v-row>

        <v-row class="mt-2" v-if="['C', 'D', 'E'].includes(etc)">
          <v-col
            v-for="type in [
              'etcRecommender',
              'etcRecommenderOrg',
              'etcRecommenderTel',
              'etcRecommenderRelation',
            ]"
            :key="type"
            cols="3"
          >
            <i-text-field
              v-maxlength="'etc_recommender'"
              :label="itemLabel(type)"
              v-model="recommender[type]"
              outlined
              dense
              hide-details="auto"
              @blur="save"
              :rules="[rules.required(type), rules.maxlength(type)]"
              class="rounded-l-0 rounded-r"
              :readonly="isReadonly"
            ></i-text-field>
          </v-col>
        </v-row>

        <v-row v-if="etc == 'D'">
          <v-col cols="12">
            <i-text-field
              v-maxlength="'etc_salary'"
              v-model="salary"
              :label="itemLabel('etcSalary')"
              outlined
              @blur="save"
              dense
              hide-details="auto"
              :rules="[rules.required('etcSalary')]"
              class="rounded-l-0 rounded-r"
              :readonly="isReadonly"
            ></i-text-field>
          </v-col>
        </v-row>

        <v-row v-if="etc == 'E'" class="mt-2">
          <v-col cols="4">
            <i-text-field
              v-maxlength="'etc_salary'"
              v-model="salary"
              :label="itemLabel('etcSalary')"
              outlined
              @blur="save"
              dense
              hide-details="auto"
              :rules="[rules.required('etcSalary')]"
              class="rounded-l-0 rounded-r"
              :readonly="isReadonly"
            ></i-text-field>
          </v-col>
          <v-col cols="4">
            <i-text-field
              v-maxlength="'etc_current_salary'"
              v-model="currentSalary"
              :label="itemLabel('etcCurrentSalary')"
              @blur="save"
              outlined
              dense
              hide-details="auto"
              :rules="[rules.required('etcCurrentSalary')]"
              class="rounded-l rounded-r-0"
              :readonly="isReadonly"
            ></i-text-field>
          </v-col>
          <v-col cols="4">
            <i-text-field
              v-maxlength="'etc_position'"
              v-model="position"
              :label="itemLabel('etcPosition')"
              outlined
              @blur="save"
              dense
              hide-details="auto"
              :rules="[rules.required('etcPosition')]"
              class="rounded-l-0 rounded-r"
              :readonly="isReadonly"
            ></i-text-field>
          </v-col>
        </v-row>
        <v-row v-if="etc == 'F'" class="mt-2">
          <v-col cols="6">
            <i-text-field
              v-maxlength="'etc_current_salary'"
              v-model="currentSalary"
              :label="itemLabel('etcCurrentSalary')"
              @blur="save"
              outlined
              dense
              hide-details="auto"
              :rules="[rules.required('etcCurrentSalary')]"
              class="rounded-l rounded-r-0"
              :readonly="isReadonly"
            ></i-text-field>
          </v-col>
          <v-col cols="6">
            <i-text-field
              v-maxlength="'etc_position'"
              v-model="position"
              :label="itemLabel('etcPosition')"
              outlined
              @blur="save"
              dense
              hide-details="auto"
              :rules="[rules.required('etcPosition')]"
              class="rounded-l-0 rounded-r"
              :readonly="isReadonly"
            ></i-text-field>
          </v-col>
        </v-row>
      </v-form>
    </div>
  </div>
</template>

<script>
import { formatPhoneNumber } from '@/utils/filters';
import DirectInputSelect from '@/components/common/DirectInputSelect.vue';
import { snack } from '@/plugins/dialog/api';
export default {
  components: { DirectInputSelect },
  props: {
    template: { type: Object },
    info: { type: Object },
    opts: { type: Object },
    rules: { type: Object },
    itemArray: {
      type: Function,
      default: () => {},
    },
    itemDirectInput: {
      type: Function,
      default: () => {},
    },

    isReadonly: {
      type: Boolean,
      default: function() {
        return true;
      },
    },
  },
  mounted() {
    this.setting();
  },
  data: () => ({
    etc: '',
    phoneNumber: '',
    path: '',
    recommender: {
      etcRecommender: '',
      etcRecommenderOrg: '',
      etcRecommenderTel: '',
      etcRecommenderRelation: '',
    },
    position: '',
    currentSalary: '',
    salary: '',
    itemDelimeter: '#',
    alert: false,
  }),
  methods: {
    itemLabel: function(key) {
      var label = this.template[key];

      if (this.opts && this.opts.hasOwnProperty(key)) {
        label =
          this.opts[key].oRequireYn === 'Y'
            ? '*' + this.$t(label)
            : this.$t(label);
      }

      return label;
    },
    setting: function() {
      if (this.template.typeEtc) this.etc = this.template.typeEtc;
      this.settingData();
    },
    settingData: function() {
      if (this.info && this.info.etc) {
        const {
          etcPath: path,
          etcRecommender,
          etcRecommenderOrg,
          etcRecommenderTel,
          etcRecommenderRelation,
          etcPhoneSub: phoneNumber,
          etcSalary: salary,
          etcCurrentSalary: currentSalary,
          etcPosition: position,
        } = this.info.etc;
        Object.assign(this, {
          path,
          phoneNumber,
          salary,
          currentSalary,
          position,
          recommender: {
            etcRecommender,
            etcRecommenderOrg,
            etcRecommenderTel,
            etcRecommenderRelation,
          },
        });
      }
    },
    formattedPhoneNumber: function() {
      this.phoneNumber = formatPhoneNumber(this.phoneNumber);
      this.save();
    },
    valid: function() {
      return this.$refs.form.validate();
    },
    save: function() {
      const id = {
        annoId: this.$route.params.annoId,
      };
      const p = {
        id: id,
        etcSalary: this.salary,
        ...this.recommender,
        etcPath: this.path,
        etcPhoneSub: this.phoneNumber,
        etcPosition: this.position,
        etcCurrentSalary: this.currentSalary,
      };

      this.$emit('save', p, 'etc');
    },
    savecallback: function(res) {
      if (res.status !== 200) {
        console.log('ETC SAVE FAIL');
      } else snack.info(`${this.template.etcTitle}정보가 저장 되었습니다.`);
    },
  },
};
</script>

<style>
.v-parallax {
  height: 100% !important;
}
.guide-common {
  min-height: calc(100vh - 64px - 122px);
}

.item-common .header .title {
  font-size: 18px;
  font-weight: bold;
  line-height: 2.67;
  letter-spacing: -0.36px;
  color: #292929;
}
.item-common .header .desc {
  margin-top: 10px;
  font-size: 14px;
  line-height: 1.43;
  letter-spacing: -0.28px;
  color: #555555;
}
.item-common .body {
  margin-top: 22px;
}
.item-common .body .v-divider {
  margin-top: 20px;
  margin-bottom: 20px;
}

.item-common .row {
  margin: 0px;
}
.item-common .col {
  padding: 0px;
}
.item-common .v-text-field {
  min-height: 36px;
}
.btn-post-wrap {
  position: relative;
}
.btn-post {
  position: absolute;
  top: 6px;
  right: 5px;
}

.type-etc .sub-title-standard {
  position: relative;
}
.type-etc .sub-title-standard .v-input__slot {
  padding-left: 100px !important;
}
.type-etc .sub-title-standard .sub-title {
  position: absolute;
  left: 10px;
  top: 10px;
  font-size: 14px;
  font-weight: 700;
  color: #363c43;
}
/* i-select height */
.i-select.v-text-field--outlined:not(.v-text-field--single-line).v-input--dense
  .i-select__selections {
  padding: 2px 0px;
}
</style>
